import { Link } from '@remix-run/react';
import { cn } from '@rocco/utils/cn';
import { AltusSponsorLogo, ALTUS_PROFILE_PATH } from './icons/AltusSponsorLogo';
interface HDEPresentedByMarkProps {
    /** Sponsor logo from EventDetails.PresentedBy (CMS). */
    logoUrl?: string | null;
    /** Profile link when EventDetails.PresentedByProfessional is set. */
    profilePath?: string | null;
    sponsorName?: string | null;
    className?: string;
    /** Tailwind classes for the CMS image (width/height). */
    imageClassName: string;
    /** Tailwind classes for the inline Altus SVG fallback. */
    fallbackLogoClassName: string;
}

/**
 * Renders the HDE “Presented by” mark: CMS logo when configured, otherwise the Altus SVG fallback.
 */
export const HDEPresentedByMark = ({
    logoUrl,
    profilePath,
    sponsorName,
    className,
    imageClassName,
    fallbackLogoClassName,
}: HDEPresentedByMarkProps) => {
    const trimmedLogo = logoUrl?.trim() || '';
    const hasCmsLogo = trimmedLogo !== '';
    const path = profilePath?.trim() || '';
    const name = sponsorName?.trim() || '';

    const mark = hasCmsLogo ? (
        <img
            src={trimmedLogo}
            alt=""
            className={cn(
                'h-auto max-w-full object-contain brightness-0 invert',
                imageClassName,
            )}
        />
    ) : (
        <AltusSponsorLogo className={fallbackLogoClassName} />
    );

    if (path !== '') {
        return (
            <Link
                to={path}
                aria-label={
                    name !== ''
                        ? `Visit ${name} profile`
                        : 'Visit sponsor profile'
                }
                className={cn('inline-block', className)}
            >
                {mark}
            </Link>
        );
    }

    if (hasCmsLogo) {
        return (
            <span className={cn('inline-block', className)} role="presentation">
                {mark}
            </span>
        );
    }

    return (
        <Link
            to={ALTUS_PROFILE_PATH}
            aria-label={
                name !== '' ? `Visit ${name} profile` : 'Visit sponsor profile'
            }
            className={cn('inline-block', className)}
        >
            {mark}
        </Link>
    );
};
